import zxcvbn from "zxcvbn";

const feedbackTranslations = {
  // Warnings
  "This is a top-10 common password.":
    "Ini salah satu 10 kata sandi paling umum.",
  "This is a top-100 common password.":
    "Ini salah satu 100 kata sandi paling umum.",
  "This is a very common password.": "Ini adalah kata sandi yang sangat umum.",
  "This is similar to a commonly used password.":
    "Ini mirip dengan kata sandi yang sering digunakan.",
  "A word by itself is easy to guess.": "Satu kata saja mudah ditebak.",
  "Names and surnames by themselves are easy to guess.":
    "Nama atau nama belakang sendiri mudah ditebak.",
  "Common names and surnames are easy to guess.":
    "Nama umum atau nama belakang umum mudah ditebak.",
  "Predictable substitutions like '@' instead of 'a' don't help very much":
    "Penggantian seperti '@' menggantikan 'a' tidak membantu banyak.",
  "Use a longer keyboard pattern with more turns":
    "Gunakan pola keyboard yang lebih panjang dengan lebih banyak tikungan.",
  "Straight rows of keys are easy to guess":
    "Deretan tombol lurus mudah ditebak.",
  "Short keyboard patterns are easy to guess":
    "Pola keyboard pendek mudah ditebak.",
  "Repeats like 'aaa' are easy to guess":
    "Pengulangan seperti 'aaa' mudah ditebak.",
  "Sequences like abc or 6543 are easy to guess":
    "Urutan seperti 'abc' atau '6543' mudah ditebak.",
  "Recent years are easy to guess": "Tahun-tahun baru-baru ini mudah ditebak.",
  "Dates are often easy to guess": "Tanggal sering mudah ditebak.",
  "Avoid repeated words and characters":
    "Hindari pengulangan kata atau karakter.",
  "Avoid sequences": "Hindari urutan karakter.",
  "Avoid recent years": "Hindari tahun baru-baru ini.",
  "Avoid dates and years that are associated with you":
    "Hindari tanggal atau tahun yang berkaitan dengan Anda.",

  // Suggestions
  "Add another word or two. Uncommon words are better.":
    "Tambahkan satu atau dua kata lagi. Kata yang tidak umum lebih baik.",
  "Use a longer keyboard pattern with more turns":
    "Gunakan pola keyboard yang lebih panjang dan rumit.",
  "Use a longer keyboard pattern": "Gunakan pola keyboard yang lebih panjang.",
  "Capitalize some letters": "Gunakan huruf kapital pada beberapa posisi.",
  "All-uppercase is almost as easy to guess as all-lowercase":
    "Semua huruf kapital masih mudah ditebak, hindari penggunaan hanya huruf kapital.",
  "Reversed words aren't much harder to guess":
    "Membalik kata tidak banyak meningkatkan keamanan.",
  "Avoid repeated words and characters":
    "Hindari pengulangan karakter dan kata.",
  "Avoid sequences": "Hindari urutan karakter (seperti 'abc', '123').",
  "Avoid recent years": "Hindari menggunakan tahun baru-baru ini.",
  "Avoid dates and years that are associated with you":
    "Hindari tanggal dan tahun yang terkait dengan Anda.",
  "Add another word or two": "Tambahkan satu atau dua kata lagi.",
};

export const validatePassword = (password) => {
  const { score, feedback } = zxcvbn(password);

  let tempFeedback = feedbackTranslations[feedback.suggestions[0]];
  let tempScore = score;

  const policyRegex = /^(?=.*[0-9])(?=.*[_,.()])(?=.{10,})[A-Za-z0-9_,.()]+$/;
  if (!policyRegex.test(password)) {
    tempFeedback =
      "Password harus minimal 10 karakter, semuanya huruf besar, dengan minimal 1 angka dan 1 simbol. Simbol yang diizinkan: - _ , . ( )";
    tempScore = 1;
  }

  let validation = false;
  if (tempScore >= 3) {
    validation = true;
  }

  return { score: tempScore, feedback: tempFeedback, validation };
};
